var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`tutorial-hint floating ${_vm.visible ? 'visible' : ''} ${_vm.left ? 'left' : ''} ${_vm.right ? 'right' : ''}`},[_c('div',{staticClass:"hint-triangle"}),_c('div',{staticStyle:{"margin-right":"0.75rem"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }